module.exports = "/_next/static/images/76923a318164e5a0566c39202ff761c7-pj-woman-working@0.75x.jpg.webp";